var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cui-acl',{attrs:{"roles":['HRcreateUsersAll', 'HRcreateUsersDepartment'],"redirect":""}},[_c('new-user-form',{attrs:{"data":_vm.data,"position":_vm.position}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }